import SidebarMenu from './SidebarContainer'

export default SidebarMenu